<template>
  <div class="block" ref="deliveryExtraPayContainer">
    <div style="display: flex; align-items: center">
      <span
        class="addition-info-switcher unselectable"
        @click="toggleInput"
        @keypress="toggleInput"
      >
        У Вас платная доставка?
      </span>
      <i
        class="icon-tooltip"
        v-tooltip.top-center="{
          content:
            'Если в Вашем магазине платная доставка, вы можете указать ее стоимость. Она прибавится к сумме оплаты для получателя.',
          trigger: 'click hover',
        }"
      ></i>
    </div>
    <div class="paid-delivery" v-if="showInput || dot.deliveryExtraPay">
      <div class="string">
        <div class="fields three">
          <div class="order-input input-group input-group-right">
            <input
              type="number"
              placeholder="0"
              v-model.number="deliveryExtraPay"
              @keypress="onlyNumber"
              :class="getErrorClass('deliveryExtraPay')"
            />
            <input type="text" value="₽" disabled="disabled" />
          </div>
          <ValidationView :error-messages="getErrorMessages('deliveryExtraPay')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { maxValue, helpers } from '@vuelidate/validators'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import preventNoNumbers from '@utils/preventNoNumbers'
import validationMixinGeneral from '@apps/order-form/src/mixins/validationMixinGeneral'

const MAX_EXTRA_PRICE = 5000

export default {
  name: 'deliveryExtraPay',
  props: {
    dot: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showInput: false,
    maxExtraPrice: MAX_EXTRA_PRICE,
  }),
  mounted() {
    this.addFieldValidator('deliveryExtraPay', this.$refs.deliveryExtraPayContainer)
  },
  validations() {
    return {
      deliveryExtraPay: {
        maxValue: helpers.withMessage(
          ({ $params }) => `Максимальная сумма: ${$params.max} руб.`,
          maxValue(MAX_EXTRA_PRICE)
        ),
      },
    }
  },
  mixins: [validationMixinGeneral],
  watch: {
    deliveryExtraPay(newValue) {
    },
  },
  computed: {
    deliveryExtraPay: {
      get() {
        return this.dot.deliveryExtraPay || ''
      },
      set(value) {
        this.touchField('deliveryExtraPay')
        this.updateDot({
          dot: this.dot,
          data: { key: 'deliveryExtraPay', value: +value },
        })
        this.calculatePrice()
      },
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['updateDot']),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),
    onlyNumber(e) {
      preventNoNumbers(e)
    },
    toggleInput() {
      this.deliveryExtraPay = 0
      this.showInput = !this.showInput
    },
  },
}
</script>

<style lang="scss" scoped>
.block-title {
  display: flex;
  align-items: center;
}

.pay-delivery {
  font-weight: 700;
  color: #495057;

  background-color: transparent;
  border: none;

  transition: opacity 0.4s;

  &:hover {
    opacity: 0.6;
  }
}
</style>
